import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { NocApproverDetailModel } from "src/app/model/NocApproverDetailModel";
import { NocApproverService } from "src/app/services/noc-approver.service";
import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
import { NocRejectCaseComponent } from "./reject-case/noc-reject-case.component";
import { InAppBrowser, InAppBrowserEvent, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ESignService } from "src/app/services/esign-service.service";
import { NocApproveCaseComponent } from "./approve-case/noc-approve-case.component";
import { RejectNocCancelRequestComponent } from "./reject-cancel-noc-request/reject-cancel-noc-request.component";

@Component({
  selector: "app-secure-noc-approver",
  templateUrl: "./noc-approver.component.html",
  styleUrls: ["./noc-approver.component.scss"],
})
export class NocApproverComponent implements OnInit {
    isLoading: boolean = false;
    nocApproverDetail: NocApproverDetailModel;
    submitDisabled: boolean;
    mortKey: number;
    nocStatus: string;
    
    constructor(private router: Router, private route: ActivatedRoute, 
        private nocApproverService: NocApproverService, private iab: InAppBrowser,
        private esignService: ESignService,
        private modalCtrl: ModalController, private _snackBar: MatSnackBar) { }
    
    ngOnInit(): void { 
        this.submitDisabled = false;
        this.route.params.subscribe((params: Params) => {
            this.mortKey = +params['mortKey'];
            this.isLoading = true;
            this.nocApproverService.fetchNocApproverDetail(this.mortKey)
            .subscribe(data => {
                this.nocApproverDetail = data;
                this.isLoading = false;
            });
        });
    }

    async reject() {
        const modal = await this.modalCtrl.create({
            component: NocRejectCaseComponent,
            componentProps: {
                heading: "Reject NOC Case",
                pan: this.nocApproverDetail.applicationNo,
                applicantName: this.nocApproverDetail.applicantName
            }
        });
        modal.present();

        const { data, role } = await modal.onWillDismiss();
        
        if (role === 'reject') {
            this.onSubmit('REJECTED', data);
        }
    }

    async approve() {
        const modal = await this.modalCtrl.create({
            component: NocApproveCaseComponent,
            componentProps: {
                pan: this.nocApproverDetail.applicationNo,
                applicantName: this.nocApproverDetail.applicantName
            }
        });
        modal.present();

        const { data, role } = await modal.onWillDismiss();
        
        if (role === 'approve') {
            this.onSubmit('APPROVED', null, data);
        }
    }
    
    onSubmit(verificationType: string, rejectReason?: string, outwardNo?: string) {
        this.isLoading = true;
        this.submitDisabled = true;
        this.nocApproverService.submitVerificationDetail(
            this.mortKey, verificationType, rejectReason, outwardNo
            ).subscribe(data => {
            
            if(data.status === 'SUCCESS') {
                if(verificationType === 'APPROVED') {
                    let url = data?.url;
                    let target = "";
                    let options: InAppBrowserOptions = {
                        zoom: "no",
                        hideurlbar: "yes",
                        toolbar: "no",
                        location: "no",
                        hidenavigationbuttons: "no",
                        usewkwebview: "yes",
                    };
                    if (localStorage.getItem("platform") == "ios") {
                        target = "_blank";
                    } else {
                        target = "_self";
                    }
            
                    const browser = this.iab.create(url, target, options);
                    browser.on("loadstart").subscribe((ev: InAppBrowserEvent) => {
                        console.log('onload stop--'+ev.url);
                        if (ev.url.startsWith("http://localhost:8100/secure/verify-esign/PRO_APPROVAL")
                        || ev.url.startsWith("https://appdemo.mhada.gov.in/secure/verify-esign/PRO_APPROVAL")
                        || ev.url.startsWith("https://ihlms.mhada.gov.in/secure/verify-esign/PRO_APPROVAL")) {
                            this.isLoading = false;
                            browser.close();
                            this.isLoading = false;
                            this.router.navigate(['/secure', 'verify-esign', 'NOC_APPROVAL', data?.esignKey], { replaceUrl: true });
                            window.location.reload();
                        }
                    });
                }
                else {
                    this.isLoading = false;
                    this.nocApproverService.successToast("Applicant with Application Number - "+this.nocApproverDetail.applicationNo+" has been Rejected.");
                    this.router.navigate(['/secure', 'noc-approver-list']);
                }
            }
            else {
                this.isLoading = false;
                this._snackBar.open(data.errorMessage, "Close", {
                    horizontalPosition: "right",
                    verticalPosition: "top",
                    panelClass: "warning-toast",
                    duration: 3 * 1000,
                });
                this.submitDisabled = false;
            }
        }, error => {
            this.submitDisabled = false;
            this.isLoading = false;
            this._snackBar.open(error.errorMessage, "Close", {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
            });
        });        
    }

    cancelNoc(){
        console.log("**Cancel NOC Called**");
        this.nocApproverService.cancelNoc(this.mortKey, this.nocApproverDetail.applicationNo).subscribe(async (data) =>{
            if(data.status === 'SUCCESS') {
                this.nocApproverService.successToast("NOC has been Cancelled.");
                this.router.navigate(['/secure', 'noc-approver-list'], { replaceUrl: true });
            }
            else {
                this.nocApproverService.errorToast(data.errorMessage);
            }
        },
        (error) => {
          console.log(error);
          this.nocApproverService.errorToast(error);
        });
    }

    async confirmRejectNocCancelRequest() {
        const modal = await this.modalCtrl.create({
            component: NocRejectCaseComponent,
            componentProps: {
                heading: "Confirm Rejection of Cancel NOC Request",
                pan: this.nocApproverDetail.applicationNo,
                applicantName: this.nocApproverDetail.applicantName
            }
        });
        modal.present();

        const { data, role } = await modal.onWillDismiss();
        
        if (role === 'reject') {
            this.rejectCancelReq('REJECTED', data, this.mortKey);
        }
    }

    rejectCancelReq(verificationType: string, rejectReason?: string, mortKey?: number){
        console.log("**Reject Cancel NOC Request Called**");
        if(rejectReason == null){
            this.nocApproverService.errorToast("Please Enter Reject Reason");
        }else if(rejectReason && !rejectReason.trim()){
            this.nocApproverService.errorToast("Please Enter Reject Reason");
            return;
        }


        this.nocApproverService.rejectCancelNocRequest(rejectReason, this.mortKey, this.nocApproverDetail.applicationNo).subscribe(async (data) =>{
            if(data.status === 'SUCCESS') {
                this.nocApproverService.successToast("Request of NOC Cancellation is been Rejected.");
                this.router.navigate(['/secure', 'noc-approver-list'], { replaceUrl: true });
            }
            else {
                this.nocApproverService.errorToast(data.errorMessage);
            }
        },
        (error) => {
          console.log(error);
          this.nocApproverService.errorToast(error);
        });
    }

    async viewEsignCertificate() {
        this.nocApproverService.fetchEsignCertificate(this.mortKey)
        .subscribe(async (data) => {
            if(data.status === 'SUCCESS') {
                this.downloadFile(data.data, this.nocApproverDetail?.applicationNo+"_NOC_CERTIFICATE_"+new Date().getTime()+".pdf");
            }
            else {
                this.nocApproverService.errorToast(data.errorMessage);
            }
        });
    }

    downloadFile(base64:string | ArrayBuffer, fileName:string){
        const src = `data:text/csv;base64,${base64}`;
        const link = document.createElement("a")
        link.href = src
        link.download = fileName
        link.click()
        
        link.remove()
      }

    async viewFile(fileType, file) {
        const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
                componentProps: {
                base64: file,
                documentName: fileType,
                fileName: fileType+"_"+this.nocApproverDetail?.applicationNo+"_"+new Date().getTime()+".pdf"
            }
        });
        modal.present();

        
    }
}